import {
  actionCreator,
  checkHttpStatus,
  DELETE_DIAGNOSISCODE,
  DiagnosisActionTypes,
  GET_DIAGNOSISCODE,
  GET_DIAGNOSISCODE_BY_ID,
  jsonApiHeader,
  POST_DIAGNOSISCODE,
  showErrorMessage,
  showSuccessMessage,
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI, showWarningMessage } from '../../../../../actions/utilAction';

export const getDiagnosisCodeList = (searchObj) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(DiagnosisActionTypes.get_diagnosis_codes.REQUEST));

    let query_params = createSearchUrlForCustomAPI(searchObj);;
    fetch(`${GET_DIAGNOSISCODE}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(DiagnosisActionTypes.get_diagnosis_codes.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const saveDiagnosisCodes = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(DiagnosisActionTypes.post_diagnosis_code.REQUEST));
    fetch(`${POST_DIAGNOSISCODE}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(DiagnosisActionTypes.post_diagnosis_code.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(DiagnosisActionTypes.post_diagnosis_code.FAILURE));
        }
      });
  };
};

export const deleteDiagnosisCode = (id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(DiagnosisActionTypes.delete_diagnosis_code.REQUEST));

    fetch(`${DELETE_DIAGNOSISCODE}/${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        // console.log('response.....',response)
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(DiagnosisActionTypes.delete_diagnosis_code.SUCCESS, response));

          let searchObj = {
            sort_fields: 'id',
            sort_order: 'desc',
            contain_filters: { SearchText: null },
            pageNumber: 1,
          };
          dispatch(getDiagnosisCodeList(searchObj));

        } else if (response.statusCode === 401) {
          showWarningMessage(response.message);
          dispatch(actionCreator(DiagnosisActionTypes.delete_diagnosis_code.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(DiagnosisActionTypes.delete_diagnosis_code.SUCCESS, null));
        }
      }).catch(function(error) {
        // console.log(error);
      });
  };
};
export const getDiagnosisCodeById = (diagnosisCodeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(DiagnosisActionTypes.get_diagnosis_code_by_id.REQUEST));

    fetch(`${GET_DIAGNOSISCODE_BY_ID}/${diagnosisCodeId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(DiagnosisActionTypes.get_diagnosis_code_by_id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};




// WEBPACK FOOTER //
// ./src/modules/Masters/components/diagnosisCode/actions/DiagnosisCodeActions.js